/**
 * Strips TOC sections and converts in-document anchor links to plain text.
 * Needed because react-native-markdown-display treats anchor links as
 * external URLs, which breaks on native.
 */
export function sanitizePolicyMarkdown(markdown: string): string {
  let result = stripTableOfContents(markdown);
  result = stripAnchorLinks(result);
  return result.trim();
}

function stripTableOfContents(markdown: string): string {
  // Match a heading containing "Table of Contents" or "Contents" (any level),
  // followed by lines that are list items or blank, up to the next heading or
  // non-list content.
  const tocPattern =
    /^#{1,6}\s+(?:Table of )?Contents?\s*\n(?:(?:\s*[-*]\s+.*|[ \t]*)\n)*/gim;
  return markdown.replace(tocPattern, '');
}

function stripAnchorLinks(markdown: string): string {
  // [visible text](#anchor) → visible text
  return markdown.replace(/\[([^\]]+)\]\(#[^)]*\)/g, '$1');
}
